import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle2, AlertCircle, Lock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function RecoverPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-1253">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1254">
        {!isSubmitted ? <>
            {/* Page Header */}
            <div className="text-center mb-8" data-id="element-1255">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-purple-100 rounded-full mb-4" data-id="element-1256">
                <Lock className="w-8 h-8 text-brand-purple-600" data-id="element-1257" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-1258">
                Forgot Your Password?
              </h1>
              <p className="text-lg text-gray-600" data-id="element-1259">
                No problem! Enter your email address and we'll send you a link
                to reset your password.
              </p>
            </div>

            {/* Help Tips */}
            <Card className="p-6 mb-8 bg-blue-50 border-blue-200" data-id="element-1260">
              <h3 className="font-semibold text-blue-900 mb-3 flex items-center" data-id="element-1261">
                <AlertCircle className="w-5 h-5 mr-2" data-id="element-1262" />
                Password Not Working? Here Are a Few Suggestions:
              </h3>
              <ul className="space-y-2 text-sm text-blue-800" data-id="element-1263">
                <li className="flex items-start" data-id="element-1264">
                  <span className="font-semibold mr-2" data-id="element-1265">1.</span>
                  <span data-id="element-1266">
                    Look at your original registration email titled "Welcome to
                    Desert Sage Seminars". That email contains your username.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1267">
                  <span className="font-semibold mr-2" data-id="element-1268">2.</span>
                  <span data-id="element-1269">
                    Your browser may be saving an incorrect password. Try
                    clearing the password box and re-type the correct password.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1270">
                  <span className="font-semibold mr-2" data-id="element-1271">3.</span>
                  <span data-id="element-1272">
                    BEFORE resetting your password, add
                    Administration@DesertSageSeminars.com to your Safe Senders
                    list so that you can receive our emails.
                  </span>
                </li>
              </ul>
            </Card>

            {/* Reset Form */}
            <Card className="p-8" data-id="element-1273">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1274">
                Reset Your Password
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1275">
                <div data-id="element-1276">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1277">
                    Email Address<span className="text-red-500" data-id="element-1278">*</span>
                  </label>
                  <div className="relative" data-id="element-1279">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1280">
                      <Mail className="h-5 w-5 text-gray-400" data-id="element-1281" />
                    </div>
                    <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" placeholder="Enter your email address" required data-id="element-1282" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-1283">
                    Enter the email address associated with your account
                  </p>
                </div>

                <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-1284">
                  Send Reset Link <ArrowRight className="ml-2 h-4 w-4" data-id="element-1285" />
                </Button>
              </form>

              <div className="mt-6 pt-6 border-t border-gray-200 text-center" data-id="element-1286">
                <p className="text-sm text-gray-600" data-id="element-1287">
                  Remember your password?{' '}
                  <a href="/login-register" className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1288">
                    Back to Login
                  </a>
                </p>
              </div>
            </Card>

            {/* Support Section */}
            <div className="mt-8 text-center" data-id="element-1289">
              <p className="text-sm text-gray-600 mb-2" data-id="element-1290">
                Still having trouble?
              </p>
              <a href="/Contact" className="text-sm font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1291">
                Contact our support team
              </a>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1292">
                or call us at{' '}
                <a href="tel:602-377-6207" className="font-semibold text-gray-700 hover:text-brand-purple-600" data-id="element-1293">
                  602-377-6207
                </a>
              </p>
            </div>
          </> /* Success Message */ : <Card className="p-8 text-center" data-id="element-1294">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4" data-id="element-1295">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1296" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1297">
              Check Your Email
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-1298">
              We've sent a password reset link to:
            </p>
            <p className="text-lg font-semibold text-brand-purple-600 mb-6" data-id="element-1299">
              {email}
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left" data-id="element-1300">
              <h3 className="font-semibold text-blue-900 mb-2" data-id="element-1301">Next Steps:</h3>
              <ol className="space-y-2 text-sm text-blue-800" data-id="element-1302">
                <li className="flex items-start" data-id="element-1303">
                  <span className="font-semibold mr-2" data-id="element-1304">1.</span>
                  <span data-id="element-1305">
                    Check your email inbox for a message from Desert Sage
                    Seminars
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1306">
                  <span className="font-semibold mr-2" data-id="element-1307">2.</span>
                  <span data-id="element-1308">Click the password reset link in the email</span>
                </li>
                <li className="flex items-start" data-id="element-1309">
                  <span className="font-semibold mr-2" data-id="element-1310">3.</span>
                  <span data-id="element-1311">Create a new password for your account</span>
                </li>
              </ol>
            </div>
            <p className="text-sm text-gray-600 mb-6" data-id="element-1312">
              Didn't receive the email? Check your spam folder or{' '}
              <button onClick={() => setIsSubmitted(false)} className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1313">
                try again
              </button>
            </p>
            <Button onClick={() => window.location.href = '/login-register'} variant="outline" size="lg" data-id="element-1314">
              Back to Login
            </Button>
          </Card>}
      </div>
    </div>;
}